import { useRef } from "react";
import { cn } from "@volca/ui/lib/utils";
import type { MachineArt } from "./art/machine-art";
import { useMachineRuntime } from "./use-machine-runtime";

interface EmptyMachineProps {
  art: MachineArt;
  active?: boolean | "starting";
  className?: string;
}

export const EmptyMachine = ({ art, active, className }: EmptyMachineProps) => {
  const stage = useRef<HTMLSpanElement>(null);
  const svg = useRef<SVGSVGElement>(null);
  const initialActive = useRef(active);
  useMachineRuntime(art.front ? stage : svg, art, active);
  const classes = cn("machine h-44 w-auto", className);
  if (!art.front)
    return (
      <svg
        ref={svg}
        className={classes}
        viewBox={art.viewBox}
        aria-hidden
        focusable={false}
        data-active={
          initialActive.current ? String(initialActive.current) : undefined
        }
        dangerouslySetInnerHTML={{ __html: art.body }}
      />
    );
  return (
    <span
      ref={stage}
      className={cn(classes, "machine-stage")}
      aria-hidden
      data-active={
        initialActive.current ? String(initialActive.current) : undefined
      }
      data-view={art.viewBox}
      style={{ aspectRatio: art.viewBox.split(" ").slice(2).join(" / ") }}
    >
      <svg
        viewBox={art.viewBox}
        focusable={false}
        dangerouslySetInnerHTML={{ __html: art.body }}
      />
      <canvas className="machine-layer" />
      <svg
        className="machine-layer"
        viewBox={art.viewBox}
        focusable={false}
        dangerouslySetInnerHTML={{ __html: art.front }}
      />
    </span>
  );
};
